import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CountdownCm from "./countdown";
import { shuffle } from "shuffle-seed";
import { useIndexedDB } from "react-indexed-db-hook";
import { TbTrash } from "react-icons/tb";
import { IoIosCheckboxOutline } from "react-icons/io";
import AcceptModal from "./accept-modal";

export default function ExamQuestions({ socket, data }) {
  const { id } = useParams();
  const [exam_id, package_id] = [...id?.split("__")];
  const { getAll, add, update } = useIndexedDB("answers");
  const [DB, setDB] = useState(false);
  const [answers, setAnswers] = useState({});

  const setAnswerHandler = (key, value) => {
    console.log(key, value);
    let newAnswers = DB.options;
    newAnswers[key] = value;
    update({ ...DB, options: newAnswers }).then(
      () => {
        setAnswers({ ...data.answers, ...DB.options });
      },
      (error) => {
        console.log(error);
      }
    );
  };
  const deleteAnswerHandler = (key) => {
    let newAnswers = DB.options;
    newAnswers[key] = 5;
    update({ ...DB, options: newAnswers }).then(
      () => {
        setAnswers({ ...DB.options });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const getExamAnswersHandler = async () => {
    const db = (await getAll()).find((item) => item.exam === id);
    if (!db) {
      add({ exam: id, options: {} });
      getExamAnswersHandler();
    } else {
      setDB(db);
      setAnswers(db.options);
      console.log("db", db.options);
      console.log("mokhi", data.answers);
    }
  };

  const finishExamHandler = () => {
    console.log("run");
    socket.open()
    socket.emit(
      "finishExamSheet",
      JSON.stringify({
        exam_id,
        package_id,
        sheet_id: data.sheet.id,
        answers,
      })
    );
    socket.on("finishExamSheet", (data) => {
      console.log(data);
      if (data.message) {
        socket.emit(
          "getexam",
          JSON.stringify({
            exam_id,
            package_id,
          })
        );
      }
      
    })
  };

  useEffect(() => {
    getExamAnswersHandler();
    return () => {};
  }, []);

  if (!DB) {
    return <div></div>;
  }

  return (
    <div className="text-lg font-dana-normal p-20 max-[1250px]:px-5 max-[600px]:p-4 max-[600px]:pt-20">
      <h1 className="text-primary-500 text-4xl font-dana-bold mb-10 text-center flex flex-row justify-between items-center max-[600px]:flex-col">
        {`پکیج ${data.packageName} - آزمون ${data.examName}`}
        <span>
          <CountdownCm t={data.time} />
        </span>
      </h1>
      <p className="flex flex-row items-center gap-2">
        گزینه <IoIosCheckboxOutline /> کنار سوال برای یادآوری سوال می باشد و
        تاثیری در پاسخنامه شما ندارد
      </p>
      {data.sheet.courses.map((item, index) => (
        <Fragment key={"course_" + item.id}>
          <div className="divider divider-primary">{item.course.title}</div>
          {shuffle(item.questions, data.phone_number).map((q, index) => (
            <div key={"course-q-" + q.id}>
              <h2 className="flex items-center gap-2">
                <input
                  type="checkbox"
                  className="checkbox checkbox-primary checkbox-sm rounded-sm"
                />
                {index + 1 + "_ " + q.question}
                {{ ...data.answers, ...answers }[q.id] < 5 && (
                  <button
                    onClick={() => {
                      deleteAnswerHandler(q.id);
                    }}
                    className="btn text-red-500 btn-circle btn-ghost !aspect-square w-8 min-h-0 !h-8"
                  >
                    <TbTrash fontSize={20} />
                  </button>
                )}
              </h2>
              <div className="grid grid-cols-2 max-[1000px]:grid-cols-1 px-5">
                {shuffle(q?.options, data.full_name).map((o, i) => (
                  <div
                    onClick={() => setAnswerHandler(q.id, o.key)}
                    key={"option-" + o.key + q.id}
                    className="form-control"
                  >
                    <label className="label cursor-pointer flex flex-row-reverse items-start justify-end gap-2">
                      <span className="label-text">{o.value}</span>
                      <input
                        type="radio"
                        name={"q-" + q.id}
                        readOnly
                        className="radio checked:bg-primary-500"
                        checked={{ ...data.answers, ...answers }[q.id] == o.key}
                      />
                      {i + 1 + "_"}
                    </label>
                  </div>
                ))}
              </div>
              <div className="divider"></div>
            </div>
          ))}
        </Fragment>
      ))}
      <div className="text-red-700 flex flex-row items-center gap-4 mt-5"></div>
      <AcceptModal
        answers={answers}
        phone_number={data.phone_number}
        full_name={data.full_name}
        onOk={finishExamHandler}
        data={data.sheet.courses}
      />
    </div>
  );
}
